<template lang="pug">
  #login
    v-container.pa-0(fluid)
      v-row.full-layout(align="center" justify="center")
        v-col(xs=5 sm=5)
          v-card.pa-5(flat)
            v-row(align="center" justify="center")
              v-col(xs=7 sm=7)
                //img(src="/static/logo.png")
              v-col.pt-4(xs=12 sm=12)
                v-form.px-5
                  v-text-field(
                    label="E-mail"
                    :rules="emailRules"
                    v-model="email"
                    filled
                    hint=""
                    persistent-hint
                  )
                  v-text-field(
                    label="Contraseña"
                    :rules="passwordRules"
                    v-model="password"
                    :append-icon="!e1 ? 'visibility' : 'visibility_off'"
                    @click:append ="e1 = !e1"
                    :type="e1 ? 'password' : 'text'"
                    name="password"
                    filled
                    hint=""
                    persistent-hint
                    min="8"
                    counter
                  )
                  v-btn.main-color-button.bold.mt-5(@click="login") Entrar

</template>

<script>
import axios from "axios";

export default {
  name: "Login",
  props: {},
  data() {
    return {
      email: "",
      emailRules: [
        v => {
          return !!v || "El E-mail es requerido";
        },
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "No es una dirección de correo válida"
      ],
      e1: true,
      password: "",
      passwordRules: [
        v => {
          return !!v || "La contraseña es requerida";
        }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    login() {
      if (
        this.email === "" ||
        typeof this.email === "undefined" ||
        (this.password === "" || typeof this.password === "undefined")
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "Datos de ingreso incompletos"
        });
      } else {
        this.$store.commit("setIsLoadingState", true);
        this.$store
          .dispatch("login", { email: this.email, password: this.password })
          .then(response => {
            this.$store.dispatch("setUser", response.data.user);
            this.email = "";
            this.password = "";
            this.$router.replace("/");
            this.$store.commit("setIsLoadingState", false);
          })
          .catch(error => {
            this.$store.commit("setShowNotification", {
              type: "error",
              title: "ERROR",
              text: error.response.data.message
            });
            this.$store.commit("setIsLoadingState", false);
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
#login,
.container,
.full-layout {
  width: 100vw;
  height: 100vh;
}
#login {
  background-color: #ebebf2;
  img {
    width: 100%;
    height: auto;
  }
  button {
    width: 100%;
    height: 50px;
  }
}
</style>
